import Products from "../assets/images/products.png";
import Services from "../assets/images/services.png";
import Jobs from "../assets/images/jobs.png";
export const home = [
  {
    id: "1",
    img: Products,
    title: "Products",
    text:
      "Unburn Rooster, Burn Rooster, Unburn Drake, Organic Chicken, Chicken leg quarters, Free Range chicken, Burn Duck hen, Burn Drake",
    link: "/products",
  },
  {
    id: "2",
    img: Jobs,
    title: "Jobs",
    text: "General labour, Industrial butcher, Wholesale butcher",
    link: "/jobs",
  },
  {
    id: "3",
    img: Services,
    title: "Services",
    text:
      "There is a growing demand for Halal meat due to the diversification of the Canadian population, and the growing global Muslim population.",
    link: "/about-us",
  },
];
